module.exports = __webpack_public_path__ + "img/collect.8c7eb3de.svg";